module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/onesence-3-eefb9e0ef9918caeac9fe0ad81c2efd9.webp";